<mat-form-field [formGroup]="params.formGroup" ngClass="{{enableFocusRing?'enable-focus-ring':' '}} address-autocomplete-field full-width-field form-elements" appearance="fill">
  <mat-label aria-hidden="true" >{{ params.placeholder ? params.placeholder : null }}</mat-label>
  <input  (focus)="focusHandle()" [attr.aria-label]="params.ariaLabel"  libField [validate]="params.directiveValidators" matInput 
    (selectedPlace)="onPlaceSelect($event)"
    (blur)="blurHandle()"
    [formControl]="params.formGroup.controls[params.formControllName]"
    [readonly] = "params.readonly"
    placeholder=""
    matAutocompletePosition="below"
      (input)="getAddressSuggestions(params.formControllName)"
    maxlength="{{params.maxLength}}"
     [matAutocomplete]="autoComplete"
    attr.data-GTM={{params.gtmTag}}/>
    <mat-autocomplete #autoComplete="matAutocomplete"
                        (optionSelected)="onPlaceSelect($event)" [attr.aria-labelledby]="'autocomplete-list'">
                        <ng-container *ngIf="filteredOptions && filteredOptions!=[]">
                            <mat-option *ngFor="let option of filteredOptions;" [value]="option.full_address"
                                class="dropdown-options">
                                <p><span [innerHTML]="option.full_address"></span></p>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete> 
  <mat-error aria-hidden="true">
    <ng-container *ngIf="params.messages">
      <ng-container *ngFor="let key of Object.keys(params.messages)">
        <ng-container *ngIf="((params.formGroup).get(params.formControllName)).hasError(key)">
          {{getErrorMessage(params.messages, key, ((params.formGroup).get(params.formControllName)).value)}}
        </ng-container>
      </ng-container>
    </ng-container>
  </mat-error>
  <mat-hint *ngIf="params.assistiveText" align="start">
    <strong>{{ params.assistiveText }}</strong>
  </mat-hint>
</mat-form-field>